export interface TimeBasedSettingBaseDto
{
    getClientTxnId(): string;
    getAPartyMsisdn(): string;
    getToneId(): string;
    getLanguage(): string;
    getPriority(): string;
    getChannelId(): string;
    getServiceId(): string;
    getActivityId(): string;

    getWeeklyDays():string[];
    getStartTimestamp(): string;
    getEndTimestamp(): string;
    getTimeSettingSelected():string; // Full | Select time | Select Date and time
    getRepeatInterval():string; // None | Monthly | Yearly
}

export class TimeBasedSettingBaseDtoImpl implements TimeBasedSettingBaseDto
{
    private clientTxnId: string;
    private aPartyMsisdn: string;
    private toneId: string;
    private language: string;
    private priority: string;
    private channelId: string;
    private serviceId: string;
    private activityId: string;

    private weeklyDays: string[];
    private startTimestamp:string;
    private endTimestamp:string;
    private timeSettingSelected:string;
    private repeatInterval:string;

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 

    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }
    getServiceId(): string 
    {
        return this.serviceId;
    } 

    setActivityId(activityId: string)
    {
        this.activityId = activityId;
    }
    getActivityId(): string 
    {
        return this.activityId;
    }

    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    } 

    setPriority(priority: string)
    {
        this.priority = priority;
    }
    getPriority(): string 
    {
        return this.priority;
    } 
    
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }
    getToneId(): string 
    {
        return this.toneId;
    } 
    
    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

    setWeeklyDays(weeklyDays: string[])
    {
        this.weeklyDays = weeklyDays;
    }
    getWeeklyDays(): string[] 
    {
        return this.weeklyDays;
    }

    setStartTimestamp(startTimestamp: string)
    {
        this.startTimestamp = startTimestamp;
    }
    getStartTimestamp(): string 
    {
        return this.startTimestamp;
    }

    setEndTimestamp(endTimestamp: string)
    {
        this.endTimestamp = endTimestamp;
    }
    getEndTimestamp(): string 
    {
        return this.endTimestamp;
    }

    setTimeSettingSelected(timeSettingSelected: string)
    {
        this.timeSettingSelected = timeSettingSelected;
    }
    getTimeSettingSelected(): string 
    {
        return this.timeSettingSelected;
    }

    setRepeatInterval(repeatInterval: string)
    {
        this.repeatInterval = repeatInterval;
    }
    getRepeatInterval(): string 
    {
        return this.repeatInterval;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/timebasedsetting/timebasedsettingbasedto.tsx